import { post } from "./axios";

const ClientDataService = {
  registerClientData(data: any) {
    return post("client_data/", data);
  }
};

export default ClientDataService;
